<template>
  <div class="container d-flex flex-wrap mb-3">
    <div class="ml-auto">
      <ncs-pagination-title/>
      <ncs-pagination-links/>
    </div>
    <ncs-go-to-page class="ml-auto align-self-end"/>
    <div class="d-flex ml-auto align-self-end mt-3">
      <ncs-kwic-download-button/>
      <ncs-label v-if="kwicInfoVisible" id="pagination.download" class="ml-3 align-self-center" style="font-size: 17px"/>
      <navigation-download-button/>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import NavigationDownloadButton from './NavigationDownloadButton'

  export default {
    components: {NavigationDownloadButton},
    computed: {
      ...mapState({kwicInfoVisible: s => s.api.resultDisplay === 'kwic'})
    }
  }
</script>